import React, { FC } from 'react';
import { SelectableItem } from '../../../../models/CampaignModel';
import { ProductType } from '../../../../models/product/ProductType';
import ProductPrice from '../../../routes/campaign/components/product-group/product-cards/ProductPrice';
import { Button, DefaultBlockContent } from '../../../shared';
import './ProductModal.scss';
import useModal from '../../Modal';
interface Props {
  product: SelectableItem;
  isSelected: boolean;
  toggleProductSelection: (product: SelectableItem) => void;
}

const Description: FC<{ description: any }> = ({ description }) => {
  if (typeof description === 'object') {
    return <DefaultBlockContent className="description" blocks={description} renderContainerOnSingleChild />;
  }

  // biome-ignore lint/security/noDangerouslySetInnerHtml: this is fine
  return <div className="description" dangerouslySetInnerHTML={{ __html: description }} />;
};

const ProductModal: React.FC<Props> = ({ product, toggleProductSelection, isSelected }) => {
  const { close } = useModal();

  const handleClick = () => {
    toggleProductSelection(product);
    close();
  };

  return (
    <div className="product-modal">
      <h1 className="title-3">{product.displayData.name}</h1>
      <Description description={product.displayData.description} />
      {!isSelected && (
        <div className="price-and-button">
          <ProductPrice
            pricing={product.pricing}
            receiver={product.productType === ProductType.Receiver}
            optionalPriceTitle={product.displayData.optionalPriceTitle}
          />
          <Button type="secondary" onClick={() => handleClick()} aria-label={`Legg til ${product.displayData.name} i handlekurv`}>
            Legg til
          </Button>
        </div>
      )}
    </div>
  );
};

export default ProductModal;
